/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const TotalIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="-1 -1 63 63"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3">
      <circle cx="29.7777778" cy="29.7777778" r="29.3333333" />
      <polyline points="43.1111111 44.1111111 17.1111111 44.1111111 31.8444444 29.5411099 17.1111111 15.1111111 43.1111111 15.1111111" />
    </g>
  </svg>
);

export default TotalIcon;
